export default function UserUsageTable({
  userData,
}) {
  return (
    <table className="dashboard-table">
      <thead>
        <tr>
          <th className="dashboard-table-th">Email</th>
          <th className="dashboard-table-th">Name</th>
          <th className="dashboard-table-th">Main Page (Index) Requests</th>
          <th className="dashboard-table-th">Single Tipsheet Requests</th>
        </tr>
      </thead>
      <tbody>
        {userData.map((user, i) => {
          return (
            <tr key={i} className={i % 2 === 0 ? "dashboard-table-tr-even" : ""}>
              <td className="dashboard-table-td">{user["email"]}</td>
              <td className="dashboard-table-td">{user["name"]}</td>
              <td className="dashboard-table-td">{user["Index"]}</td>
              <td className="dashboard-table-td">{user["Tip Sheet"]}</td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr style={{ backgroundColor: "#0e4c60", color: "white" }}>
          <td className="dashboard-table-td">Unique Visitors:</td>
          <td className="dashboard-table-td" colSpan={3}>{userData.length}</td>
        </tr>
      </tfoot>
    </table>
  )
}